import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Training Progress Report")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Tranche", -1)
const _hoisted_12 = ["label", "value"]
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Training Partner", -1)
const _hoisted_17 = ["label", "value"]
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Course Type", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Course Category", -1)
const _hoisted_23 = { class: "row mt-4" }
const _hoisted_24 = { class: "col-md-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Start Date", -1)
const _hoisted_26 = { class: "col-md-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "End Date", -1)
const _hoisted_28 = { class: "col-md-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Employment Eligibility", -1)
const _hoisted_30 = { class: "col-md-2 mt-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_32 = {
  class: "card-header border-0 cursor-pointer bg-light px-2",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#trainer_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_33 = { class: "row mt-1 w-100 m-0" }
const _hoisted_34 = { class: "col-md-6 my-auto" }
const _hoisted_35 = { class: "div" }
const _hoisted_36 = { style: {"line-height":"1.6"} }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = { class: "col-md-6 text-end my-auto" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_47 = { class: "card-body p-5 py-3" }
const _hoisted_48 = { class: "table-responsive sticky mt-3" }
const _hoisted_49 = { class: "table table-bordered table-row-bordered table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "w-25px text-center align-middle border border-gray-400",
      rowspan: "2"
    }, " SL "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "w-250px text-left align-middle border border-gray-400",
      rowspan: "2"
    }, " Batch No "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "w-250px text-left align-middle border border-gray-400",
      rowspan: "2"
    }, " Batch Duration "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-140px text-center align-middle border border-gray-400",
      colspan: "3"
    }, " Enrollment "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-120px text-center align-middle border border-gray-400",
      colspan: "4"
    }, " Assessment "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-120px text-center align-middle border border-gray-400",
      colspan: "3"
    }, " Certification "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-120px text-center align-middle border border-gray-400",
      colspan: "5"
    }, " Job placement ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-black border border-gray-400" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"}
    }, " Net "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"}
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"}
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"}
    }, " Absent "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Dropout "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"},
      rowspan: "2"
    }, [
      /*#__PURE__*/_createTextVNode(" Certification "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("(JP Window End) ")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Percentage(%) "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " JP Window End "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400",
      style: {"text-align":"center"},
      rowspan: "2"
    }, [
      /*#__PURE__*/_createTextVNode(" Percentage "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("(JP Window End) (%) ")
    ])
  ])
], -1)
const _hoisted_51 = { style: {} }
const _hoisted_52 = { class: "text-dark fw-bolder text-black fs-6 text-start" }
const _hoisted_53 = { class: "text-dark text-black fs-6 text-start" }
const _hoisted_54 = ["href"]
const _hoisted_55 = ["href"]
const _hoisted_56 = ["href"]
const _hoisted_57 = ["href"]
const _hoisted_58 = ["href"]
const _hoisted_59 = ["href"]
const _hoisted_60 = ["href"]
const _hoisted_61 = ["href"]
const _hoisted_62 = ["href"]
const _hoisted_63 = ["href"]
const _hoisted_64 = ["href"]
const _hoisted_65 = ["href"]
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { class: "border border-gray-400 text-center" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "3",
  class: "font-weight-bold text-black"
}, " Total ", -1)
const _hoisted_72 = { class: "font-weight-bold text-black" }
const _hoisted_73 = { class: "font-weight-bold text-black" }
const _hoisted_74 = { class: "font-weight-bold text-black" }
const _hoisted_75 = { class: "font-weight-bold text-black" }
const _hoisted_76 = { class: "font-weight-bold text-black" }
const _hoisted_77 = { class: "font-weight-bold text-black" }
const _hoisted_78 = { class: "font-weight-bold text-black" }
const _hoisted_79 = { class: "font-weight-bold text-black" }
const _hoisted_80 = { class: "font-weight-bold text-black" }
const _hoisted_81 = { class: "font-weight-bold text-black" }
const _hoisted_82 = { class: "font-weight-bold text-black" }
const _hoisted_83 = { class: "font-weight-bold text-black" }
const _hoisted_84 = { class: "font-weight-bold text-black" }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = { class: "font-weight-bold text-black" }
const _hoisted_88 = { class: "font-weight-bold text-black" }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _withDirectives(_createElementVNode("select", {
                  class: "form-control py-2",
                  placeholder: "Select Tranche",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                  style: {"width":"100%"}
                }, [
                  _hoisted_11,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: tranche.id,
                      label: tranche.label,
                      value: tranche.id
                    }, _toDisplayString(tranche.label), 9, _hoisted_12))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.batch.tranche_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _hoisted_15,
                _withDirectives(_createElementVNode("select", {
                  class: "form-control py-2",
                  placeholder: "Select Training Partner",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                  style: {"width":"100%"}
                }, [
                  _hoisted_16,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: info.id,
                      label: 
                      '[' + info.entity_short_name + '] - ' + info.entity_name
                    ,
                      value: info.id
                    }, _toDisplayString('[' + info.entity_short_name + '] - ' + info.entity_name), 9, _hoisted_17))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.batch.entity_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _hoisted_20,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Course Type",
                  modelValue: _ctx.batch.course_type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.course_type) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseTypes, (types) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: types.id,
                        label: types.type_name,
                        value: types.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(types.type_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Course Category",
                  modelValue: _ctx.batch.course_category,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course_category) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  name: "course_category"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (data) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: data.id,
                        label: data.category_name,
                        value: data.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.category_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_el_form_item, { prop: "start_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.batch.start_date,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.start_date) = $event)),
                        "value-format": "YYYY-MM-DD",
                        format: "DD-MM-YYYY",
                        style: {"width":"100%"},
                        type: "date",
                        name: "start_date"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode(_component_el_form_item, { prop: "end_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.batch.end_date,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.end_date) = $event)),
                        "value-format": "YYYY-MM-DD",
                        format: "DD-MM-YYYY",
                        style: {"width":"100%"},
                        type: "date",
                        name: "end_date"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Employment Eligibility",
                    modelValue: _ctx.is_motor_driving,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.is_motor_driving) = $event)),
                    filterable: "",
                    style: {"width":"100%"},
                    name: "is_motor_driving"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Employment Eligible",
                        value: "2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Employment Eligible")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Employment Not Eligible",
                        value: "1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Employment Not Eligible")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getBatchProgress())),
                    type: "button",
                    class: "btn btn-success mt-6 p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_31
                  ])
                ])
              ])
            ]),
            (_openBlock(), _createElementBlock("div", {
              class: "card mb-5 mb-xl-10",
              key: _ctx.componentKey
            }, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("h6", _hoisted_36, [
                        _createTextVNode(" Batch Wise Training Summary ( Total : " + _toDisplayString(_ctx.batchData.length) + " ) ", 1),
                        _hoisted_37,
                        _createTextVNode(" Course: " + _toDisplayString(_ctx.course_name) + " ", 1),
                        _hoisted_38,
                        _createTextVNode(" Institute : " + _toDisplayString(_ctx.institute_name), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                      title: "Download Xlse",
                      "data-v-54b12dc8": "",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.exportTrainee()))
                    }, _hoisted_41),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                      title: "Download PDF",
                      "data-v-54b12dc8": "",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.downloadPdf()))
                    }, _hoisted_43),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                      title: "Print",
                      "data-v-54b12dc8": "",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.printPdf()))
                    }, _hoisted_45),
                    _hoisted_46
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("table", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("tbody", _hoisted_51, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchData, (data, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: "border border-gray-400 text-center"
                        }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", _hoisted_52, _toDisplayString(data?.batch_info?.batch_number), 1),
                          _createElementVNode("td", _hoisted_53, _toDisplayString(new Date(data?.batch_info?.start_date)
                                .toLocaleDateString(undefined, {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                })
                                .split('/')
                                .join('-')) + " To " + _toDisplayString(new Date(data?.batch_info?.end_date)
                                .toLocaleDateString(undefined, {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                })
                                .split('/')
                                .join('-')), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: `${this.VUE_APP_TMS}/batch-trainee-summary/` +
                                    data?.batch_info?.id +
                                    '/' +
                                    1 +
                                    '/' +
                                    1 
                                    ,
                              target: "_blank",
                              class: "text-primary"
                            }, _toDisplayString(Number(data?.t_enrolled).toLocaleString()), 9, _hoisted_54)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: `${this.VUE_APP_TMS}/batch-trainee-summary/` +
                                   data?.batch_info?.id +
                                   '/' +
                                   1 +
                                   '/' +
                                   2
                                   ,
                              target: "_blank",
                              class: "text-primary"
                            }, _toDisplayString(Number(
                                      data?.t_enrolled - data?.t_dropout
                                    ).toLocaleString()), 9, _hoisted_55)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: `${this.VUE_APP_TMS}/batch-trainee-summary/` +
                                      data?.batch_info?.id +
                                      '/' +
                                      1 +
                                      '/' +
                                      3
                                      ,
                              target: "_blank",
                              class: "text-primary"
                            }, _toDisplayString(Number(data?.f_enrolled).toLocaleString()), 9, _hoisted_56)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: `${this.VUE_APP_TMS}/batch-trainee-summary/` +
                                      data?.batch_info?.id +
                                      '/' +
                                      2 +
                                      '/' +
                                      1
                                      ,
                              target: "_blank",
                              class: "text-primary"
                            }, _toDisplayString(Number(data?.t_assessed).toLocaleString()), 9, _hoisted_57)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: `${this.VUE_APP_TMS}/batch-trainee-summary/` +
                                       data?.batch_info?.id +
                                       '/' +
                                       2 +
                                       '/' +
                                       2
                                       ,
                              target: "_blank",
                              class: "text-primary"
                            }, _toDisplayString(Number(data?.f_assessed).toLocaleString()), 9, _hoisted_58)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: `${this.VUE_APP_TMS}/batch-trainee-summary/` +
                                         data?.batch_info?.id +
                                         '/' +
                                         2 +
                                         '/' +
                                         3
                                         ,
                              target: "_blank",
                              class: "text-primary"
                            }, _toDisplayString(Number(data?.t_absent).toLocaleString()), 9, _hoisted_59)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: `${this.VUE_APP_TMS}/batch-trainee-summary/` +
                                           data?.batch_info?.id +
                                           '/' +
                                           2 +
                                           '/' +
                                           4
                                           ,
                              target: "_blank",
                              class: "text-primary"
                            }, _toDisplayString(Number(data?.t_dropout).toLocaleString()), 9, _hoisted_60)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: `${this.VUE_APP_TMS}/batch-trainee-summary/` +
                               data?.batch_info?.id +
                               '/' +
                               3 +
                               '/' +
                               1
                               ,
                              target: "_blank",
                              class: "text-primary"
                            }, _toDisplayString(Number(data?.t_certified).toLocaleString()), 9, _hoisted_61)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: `${this.VUE_APP_TMS}/batch-trainee-summary/` +
                                    data?.batch_info?.id +
                                    '/' +
                                    3 +
                                    '/' +
                                    2
                                    ,
                              target: "_blank",
                              class: "text-primary"
                            }, _toDisplayString(Number(data?.f_certified).toLocaleString()), 9, _hoisted_62)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: `${this.VUE_APP_TMS}/batch-trainee-summary/` +
                               data?.batch_info?.id +
                               '/' +
                               3 +
                               '/' +
                               3
                               ,
                              target: "_blank",
                              class: "text-primary"
                            }, _toDisplayString(Number(data?.certified_3m).toLocaleString()), 9, _hoisted_63)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: `${this.VUE_APP_TMS}/batch-trainee-summary/` +
                                data?.batch_info?.id +
                                '/' +
                                4 +
                                '/' +
                                1
                                ,
                              target: "_blank",
                              class: "text-primary"
                            }, _toDisplayString(Number(data?.t_employed).toLocaleString()), 9, _hoisted_64)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: `${this.VUE_APP_TMS}/batch-trainee-summary/` +
                                data?.batch_info?.id +
                                '/' +
                                4 +
                                '/' +
                                2
                                ,
                              target: "_blank",
                              class: "text-primary"
                            }, _toDisplayString(Number(data?.f_employed).toLocaleString()), 9, _hoisted_65)
                          ]),
                          _createElementVNode("td", null, [
                            (data?.t_certified > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString((
                                  (data?.t_employed / data?.t_certified) *
                                  100
                                ).toFixed(2)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_67, "0.00"))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.employed_3m).toLocaleString()), 1),
                          _createElementVNode("td", null, [
                            (data?.certified_3m > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString((
                                  (data?.t_employed / data?.certified_3m) *
                                  100
                                ).toFixed(2)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_69, "0.00"))
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", _hoisted_70, [
                        _hoisted_71,
                        _createElementVNode("th", _hoisted_72, _toDisplayString(Number(_ctx.reportData?.total_enrolled).toLocaleString()), 1),
                        _createElementVNode("th", _hoisted_73, _toDisplayString(Number(
                              _ctx.reportData?.total_enrolled -
                                _ctx.reportData?.total_dropout
                            ).toLocaleString()), 1),
                        _createElementVNode("th", _hoisted_74, _toDisplayString(Number(_ctx.reportData?.female_enrolled).toLocaleString()), 1),
                        _createElementVNode("th", _hoisted_75, _toDisplayString(Number(_ctx.reportData?.total_assessed).toLocaleString()), 1),
                        _createElementVNode("th", _hoisted_76, _toDisplayString(Number(_ctx.reportData?.female_assessed).toLocaleString()), 1),
                        _createElementVNode("th", _hoisted_77, _toDisplayString(Number(_ctx.reportData?.total_absent).toLocaleString()), 1),
                        _createElementVNode("th", _hoisted_78, _toDisplayString(Number(_ctx.reportData?.total_dropout).toLocaleString()), 1),
                        _createElementVNode("th", _hoisted_79, _toDisplayString(Number(_ctx.reportData?.total_certified).toLocaleString()), 1),
                        _createElementVNode("th", _hoisted_80, _toDisplayString(Number(
                              _ctx.reportData?.female_certified
                            ).toLocaleString()), 1),
                        _createElementVNode("th", _hoisted_81, _toDisplayString(Number(
                              _ctx.reportData?.total_certified_3m
                            ).toLocaleString()), 1),
                        _createElementVNode("th", _hoisted_82, _toDisplayString(Number(_ctx.reportData?.total_employed).toLocaleString()), 1),
                        _createElementVNode("th", _hoisted_83, _toDisplayString(Number(_ctx.reportData?.female_employed).toLocaleString()), 1),
                        _createElementVNode("th", _hoisted_84, [
                          (_ctx.reportData?.total_certified > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString((
                                (_ctx.reportData?.total_employed /
                                  _ctx.reportData?.total_certified) *
                                100
                              ).toFixed(2) > 100
                                ? 100
                                : (
                                    (_ctx.reportData?.total_employed /
                                      _ctx.reportData?.total_certified) *
                                    100
                                  ).toFixed(2)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_86, "0.00"))
                        ]),
                        _createElementVNode("th", _hoisted_87, _toDisplayString(Number(_ctx.reportData?.total_employed_3m).toLocaleString()), 1),
                        _createElementVNode("th", _hoisted_88, [
                          (_ctx.reportData?.total_certified_3m > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_89, _toDisplayString((
                                (_ctx.reportData?.total_employed_3m /
                                  _ctx.reportData?.total_certified_3m) *
                                100
                              ).toFixed(2) > 100
                                ? 100
                                : (
                                    (_ctx.reportData?.total_employed_3m /
                                      _ctx.reportData?.total_certified_3m) *
                                    100
                                  ).toFixed(2)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_90, "0.00"))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}